import { render, staticRenderFns } from "./IntlHeader.vue?vue&type=template&id=f79f2e1c&scoped=true"
import script from "./IntlHeader.vue?vue&type=script&lang=js"
export * from "./IntlHeader.vue?vue&type=script&lang=js"
import style0 from "./IntlHeader.vue?vue&type=style&index=0&id=f79f2e1c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79f2e1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f79f2e1c')) {
      api.createRecord('f79f2e1c', component.options)
    } else {
      api.reload('f79f2e1c', component.options)
    }
    module.hot.accept("./IntlHeader.vue?vue&type=template&id=f79f2e1c&scoped=true", function () {
      api.rerender('f79f2e1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/international/components/IntlHeader.vue"
export default component.exports